import i18n from '~/i18n';

export default (userData, defaultName) => {
    return userData.firstName && userData.lastName
        ? userData.firstName + ' ' + userData.lastName
        : userData.firstName
        ? userData.firstName
        : userData.lastName
        ? userData.lastName
        : i18n.t(defaultName);
};
